import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Session } from './session';
export { Session };
import { sessionSchema } from '@schemas/business-objects/session';
import { AttendanceFormGroup } from './attendance-form-group';
import { CurriculumFormGroup } from './curriculum-form-group';
import { SessionActivityItemFormArray } from './session-activity-item-form-group';

export class SessionFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    date: SchemaFormControl;
    comments: SchemaFormControl;
    sessionLengthMinutes: SchemaFormControl;
    complete: SchemaFormControl;
    sessionNumber: SchemaFormControl;
    attendanceId: SchemaFormControl;
    attendance: AttendanceFormGroup;
    curriculumId: SchemaFormControl;
    curriculum: CurriculumFormGroup;
    sessionActivityItems: SessionActivityItemFormArray;
  };

  declare value: Partial<Session>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(sessionSchema, Session, data, options);
  }

  get object(): Session {
    return new Session(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'attendance':
        return new AttendanceFormGroup();
      case 'curriculum':
        return new CurriculumFormGroup();
      case 'sessionActivityItems':
        return new SessionActivityItemFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Session[]> {
    return Session.find(filter);
  }

  static async findOne(filter?: any): Promise<Session | null> {
    return Session.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Session> {
    return Session.findById(id, filter);
  }

  static async create(data: Partial<Session>): Promise<Session> {
    return Session.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Session>,
  ): Promise<Session> {
    return Session.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Session.deleteById(id);
  }
}

export class SessionFormArray extends PersistedFormArray {
  readonly entityName = 'Session' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(sessionSchema, Session, options);
  }

  protected override createItemGroup() {
    return new SessionFormGroup();
  }

  get array(): Session[] {
    return this.controls.map((group: SessionFormGroup) => group.object);
  }
}

export class SessionPersistedArray extends PersistedArray<Session> {
  readonly entityName = 'Session' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Session, options);
  }
}
